import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'
import * as filters from '../../filters/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-billing-discrepancy-request-type-dropdown',
  templateUrl: './BillingDiscrepancyRequestTypeDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => BillingDiscrepancyRequestTypeDropdownComponent)}]
})
export class BillingDiscrepancyRequestTypeDropdownComponent extends BaseDropdownComponent {

    constructor(private domainDataService: serv.DomainDataService) 
    { 
        super();
    }


    ngOnInit(): void {
    }

    public load(){

        var filter: filters.BillingDiscrepancyRequestTypeFilter = {IncludeInactive: false};
        this.domainDataService.getBillingDiscrepancyRequestTypes(filter).subscribe(x=> {
            this.selectItems.push({label:"", value:Constants._NONE});
            x.forEach(y=> this.selectItems.push({label:y.Name, value:y.ID}));
            if (this.selectedID){
                this.value = this.selectedID;
            }
            });
    }
    
    

}